import { render, staticRenderFns } from "./OperationConfigCat.vue?vue&type=template&id=21ecfe40&scoped=true"
import script from "./OperationConfigCat.vue?vue&type=script&lang=js"
export * from "./OperationConfigCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ecfe40",
  null
  
)

export default component.exports